import { render, staticRenderFns } from "./DeckForm.vue?vue&type=template&id=8c9b8fba&scoped=true&"
import script from "./DeckForm.vue?vue&type=script&lang=js&"
export * from "./DeckForm.vue?vue&type=script&lang=js&"
import style0 from "./DeckForm.vue?vue&type=style&index=0&id=8c9b8fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b8fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
